import NotFoundPlaceholder from '../../public/static/no-image-found.png'
import no_restaurant_image from '../../public/static/no-data-images/no restaurants.png'
import no_food_found_image from '../../public/static/no-data-images/no food.png'
import no_order_found_image from '../../public/static/no-data-images/No order in history.png'
import no_address_found_image from '../../public/static/no-data-images/no-address-data.svg'
import no_translation_found from '../../public/static/lagNodata.png'
import no_data_found from '../../public/static/no-data-images/Asset 3 1.png'

export const imageNotFoundPlaceholder = NotFoundPlaceholder
export const noRestaurantsImage = no_restaurant_image
export const noFoodFoundImage = no_food_found_image
export const noOrderFound = no_order_found_image
export const noAddressFound = no_address_found_image
export const noTransactionFound = no_translation_found
export const noDataFound = no_data_found
